// Profile "הגדרת סיסמה" (Option B, 2026-10-21). Pure — no Firebase, no network — so every branch is unit-tested.
//
// Who may ask for a password-setup email from the Profile: a signed-in user whose Firebase account signs in with
// Google, has NO password yet, and whose account email is verified. The email always goes to that account email
// (never to an address typed in the Profile). Everything else gets no button:
//   signed_out        no Firebase user
//   not_google        email / password account (it already has a password and the login screen's reset)
//   has_password      Google + password: both sign-in methods already work
//   email_unverified  the account email is missing or not verified — nothing is sent to an unverified address
// The password itself is set from Firebase's existing reset-email link — the path validated on a test account
// (same Firebase UID, Google sign-in kept). The Firebase user is never linked, unlinked or edited here.

export function passwordSetupStatus(user) {
  if (!user) return { eligible: false, reason: 'signed_out' };
  const providers = (user.providerData || []).map((p) => p && p.providerId);
  if (!providers.includes('google.com')) return { eligible: false, reason: 'not_google' };
  if (providers.includes('password')) return { eligible: false, reason: 'has_password' };
  const email = typeof user.email === 'string' ? user.email.trim() : '';
  if (!email || user.emailVerified !== true) return { eligible: false, reason: 'email_unverified' };
  return { eligible: true, email };
}
